
// Set the defaults fancybox options
if (typeof $.fancybox !== 'undefined') {
    $.fancybox.defaults.loop = true;
}
/** 
 * ******************************************
 * DOCUMENT LISTENER EVENTS
 * ******************************************
 */

/**
 * START: click of avaspin to toggle "get custom product modal"
 */
$(document).on('click', '#topDiscountCode, #topDiscountCodeMiddle', function (e) {
    $("#getCustomProduct").modal("show");
});


/**
 * Handles click event for custom product PIN submission
 * Retrieves product PIN value and sends request to get product details
 */

$(document).on('click', '#submitCustomProductPin', function(e) {
    const prodPin = $("#productPin").val();
    $.post('/checkout/getspecialproddetail', { prodPin }, handleProductDetailResponse);
});

/**
 * Processes the response from product detail API call
 * Updates PIN message and handles successful product detail retrieval
 * @param {Object} data - Response data from product detail API
 */
function handleProductDetailResponse(data) {
    updatePinMessage(data.message, data.status);
    
    if (data.status === true) {
        handleSuccessfulProductDetail(data.data);
    }
}

/**
 * Updates the PIN validation message with appropriate styling
 * @param {string} message - Message text to display
 * @param {boolean} isSuccess - Whether the operation was successful
 */
function updatePinMessage(message, isSuccess) {
    const $message = $("#prodPinMessage");
    $message.text(message);
    
    if (isSuccess) {
        $message.removeClass('text-danger').addClass('text-success');
    } else {
        $message.removeClass('text-success').addClass('text-danger');
    }
}

/**
 * Handles UI updates and processes successful product detail retrieval
 * Adds product to cart and triggers tracking events
 * @param {Object} prodData - Product data object from API response
 */
function handleSuccessfulProductDetail(prodData) {
    // UI updates
    $("#customProductDialogLaoder").removeClass('d-none');
    $("#submitCustomProductPin").addClass('disabled');
    
    // Add to cart
    addProductToCart(prodData);
    
    // Tracking
    trackProductEvents(prodData);
}

/**
 * Sends request to add product to checkout cart
 * Updates message based on response and redirects on success
 * @param {Object} prodData - Product data object containing product_id
 */
function addProductToCart(prodData) {
     $.post('/checkout/addtocheckoutcart', { prodId: prodData.product_id }, function(response) {
        updatePinMessage(response.message, response.status);
        if (response.status === true) {
            window.location.href = "/checkout";
        }
    });
}

/**
 * Tracks product events across multiple analytics platforms
 * Sends data to Facebook, Meta Pixel, and Google Tag Manager
 * @param {Object} prodData - Product data object containing product details
 */
function trackProductEvents(prodData) {
    const productCodes = [prodData.product_code];
    const price = parseFloat(prodData.price).toFixed(2);
    const eventId = new Date().getTime();
    
    // Meta Facebook tracking
    fbTrack('AddToCart', {
        content_ids: productCodes,
        content_type: 'product',
        value: price,
        currency: 'USD'
    }, { eventID: eventId });


    $.post('/metapixel/addtocart', {
        contentIds: productCodes,
        contentType: 'product',
        value: price,
        currency: 'USD',
        eventID: eventId
    }, function(response) {
        console.log("cart_response " + response);
    });
    
    // Google Tag Manager tracking
    const item = {
        item_id: prodData.product_id,
        item_name: prodData.product_name,
        currency: "USD",
        price: price,
        quantity: 1
    };
    
    const eventData = { send_to: 'analytics', items: [item] };
    gTagEvent('add_to_cart', eventData);
    gTagEvent('add_to_cart_product', eventData);
}
/**
 * END: toggle "get custom product modal"
 */

/**
 * START: Click event listener for a[rel="facebox"]
 */
$(document).on('click', 'a[rel="facebox"]', function(e) {
    e.preventDefault();
    const $href = $(this).attr('href');
    $('#facebox-popup-holder').load($href, function() {
        $('#facebox-popup-background').css('height', $(window).height() + 'px').show();
        let $top = 0;
        if ($('#facebox-popup-holder').height() >= $(window).height()) {
            $top = $(window).scrollTop() + 20;
        } else {
            $top = ($(window).height() - $('#facebox-popup-holder').height()) / 2 + $(window).scrollTop();
        }
        $('#facebox-popup-holder').css("top", $top + "px").show();
        $('#facebox-popup-holder').prepend('<a href="#" id="close-popup-link" class="close-facebox-link" title="Close"><img src="/newimg/popup-close.png" alt="Close" width="32" height="32" /></a>');
    });    
    return false;
});
/**
 * END: a[rel="facebox"]
 */

/**
 * START: Click event listener for .close-facebox-link
 */
$(document).on('click', '.close-facebox-link', function (e) {
    $('#facebox-popup-background').hide();
    $('#facebox-popup-holder').hide();
    $('#facebox-popup-holder').html('');
    e.preventDefault();
    return false;
});
/**
 * END: .close-facebox-link
 */

/**
 * START: Click event listener for #close-popup-link
 */
$(document).on('click', '.closePopup', function (e) {
    let target = $(this).attr('data-target');
    if (target) {
        $('#general-popup-wide-background').hide();
        $('#general-popup-wide-holder').hide();
        $('#general-popup-background').hide();
        $('#general-popup-holder').hide();
        $('#' + target).remove();
    }
    e.preventDefault();
    return false;
});
/**
 * END: #close-popup-link
 */

/**
 * START: Click event when the .mobile_phone_number_link element is clicked on.
 */

// this button is not visisble in site nav blocked at the moment
$(document).on('click', '.mobile_phone_number_link', function(e) {

    // if already in the process of the getting a phone number, do not proceed.
    if (window.requestingNumberForPhone) {
        return;
    }

    // do not proceed, if the link does not have the generate_number_for_phone class
    if (!$(this).hasClass("generate_number_for_phone")) {
        return;
    }

    // indicating request is being processed
    window.requestingNumberForPhone = true;

    // get all phone links
    const allLinks = $(".mobile_phone_number_link");
    const formattedPhoneNumberSpans = $(".formatted_phone_number");

    $.ajax("/ajax/assignphonenumber", {
        method: "POST",
        dataType: "json",
        success: function (data, textStatus, jqXHR) {
            if (data.success) {
                // set the href and remove class "generate_number_for_phone"
                allLinks.each(function () {
                    $(this).attr("href", data.hrefLinkAttr);
                    $(this).removeClass("generate_number_for_phone");
                });

                // add the formatted phone number to each related phone link
                formattedPhoneNumberSpans.each(function () {
                    $(this).text(data.formattedPhone);
                });

                // initiate phone call
                location.href = data.hrefLinkAttr;
            }

            window.requestingNumberForPhone = false;
        },
        error: function (jqXHR, textStatus, errorThrown) {
            window.requestingNumberForPhone = false;

            let errMsg = "AJAX failed. Could not generate a number for a phone device.";
            errMsg += "\nStatus: " + textStatus;
            errMsg += "\nError: " + errorThrown;

            const errObj = new Error(errMsg);
            logError(errObj);
        }
    });
});  

/**
 * START: Click event listener for #show-more-feat-products
 */
$(document).on('click', '#show-more-feat-products', function (e) {
    $(this).parent().parent().find('.show-more-link').hide();
    $(this).parent().parent().find('.show-more-loader').show();
    let $params = $(this).attr('data-cat').replace('featcount-', '');
    $params = $params.split('-');
    $('#product-load-holder').load('/ajax/reloadfeat/' + $params, function () {
        $('.show-more-box').replaceWith($('#product-load-holder').html());
    });
    e.preventDefault();
    return false;
});
/**
 * END: #show-more-feat-products
 */

/**
 * End: .mobile_phone_number_link
 */
$(() => {
    // Search functionality
    $('#search').on('keyup', function() {
        const searchValue = $(this).val().toLowerCase();
        if (searchValue === 'pinz') {
            const pin = $('.rkg-phone-pin').find('strong').html();
            alert(`Your Pin: ${pin}`);
            setTimeout(() => {
                $('#search').val('');
            }, 20);
        }
    });
    
    // Popup functionality
    const createPopupHandler = (width, height, windowName) => {
        return function(event) {
            const left = ($(window).width() - width) / 2;
            const top = ($(window).height() - height) / 2;
            const url = this.href;
            const opts = `status=1,width=${width},height=${height},top=${top},left=${left},scrollbars=1`;
            
            window.open(url, windowName, opts);
            event.preventDefault();
            return false;
        };
    };
    
    // Attach popup handlers
    $('.popup-800-600').on('click', createPopupHandler(800, 600, 'pop'));
    $('.popup-1024-800').on('click', createPopupHandler(1024, 800, 'pop2'));
    
    // Infinity load more
    addEvent(document, 'click', '.infinity-load-more', infinityLoadMore);
});

if (WebPageObj.checkout || WebPageObj.product) {
    $(function () {
        $('#category-head').on('click', function () {
            location.href = $(this).find('a:first-child').attr('href');
        });
    });
}
